import MainLayout from "../../layout/MainLayout";
import OverviewSection from "../../components/OverviewSection";
import FilterSection from "../../components/FilterSection";
import { Tag, Dropdown, Space } from "antd";
import DataTable from "../../common/Tables/DataTable";
import { EyeOutlined, DeleteOutlined, EllipsisOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { actionPost, getApi, useApiCall } from "../../services/api";
import useExpiredToken from "../../utils/useExpiredToken";
import { ShowData } from "../../utils/ShowData";
import { useToast } from "../../utils/Toast";
import { useNavigate } from "react-router-dom";
import { processEncryptedResponse } from "../../utils/ResponseDecreypt";
import AssignedCallDetails from "../../components/models/AssignedCallDetails";
import { filterDataFunc,QA_ROLES } from "../../constant";
import DeleteModal from "../../components/models/DeleteModal";
import DateRangeFilter from "../../components/filters/DateRangeFilter";
import dayjs from "dayjs";

const Dashboard = () => {
  const { callApi } = useApiCall();
  const [data, setData] = useState([]);
  const [overviewData, setOverviewData] = useState(null);
  const token = useSelector((state) => state.auth.jwtToken);
  const { searchText } = useSelector((state) => state.search);
  const expireToken = useExpiredToken();
  const [deleteData, setDeleteData] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const toast = useToast();
  const role = useSelector((state) => state.auth.role);
  const navigate = useNavigate();
  const [fetchRefresh, setFetchRefresh] = useState(false);

  const handleCancel = () => {
    setIsDeleteModalOpen(false);
    setIsDetailsModalOpen(false);
  };

  const handleDelete = async () => {
    // const res = await actionPost(
    //   `calls/summary`,
    //   token,
    //   "DELETE",
    //   { id: deleteData?.id },
    //   expireToken
    // );
    const { status } = await callApi({
      endpoint: `calls/summary`,
      apiMethod: "post",
      bodyData: { action: "DELETE", input: { id: deleteData?.id } },
    });
    if (status) {
      setIsDeleteModalOpen(false);
      // fetchData();
      setFetchRefresh((prev) => !prev);
    }
  };

  // const fetchData = async () => {
  //   const res = await actionPost("calls/summary", token, "READ_ALL", {}, expireToken);
  //   const data = await processEncryptedResponse(res);
  //   if (data) {
  //     setData(data);
  //   }
  // };

  const fetchOverview = async () => {
    const res = await getApi("calls/overview", token, expireToken);
    const data = await processEncryptedResponse(res);
    if (data) {
      setOverviewData(data);
    }
  };

  const mappedData = data?.map((item) => ShowData(item));

  const filteredData = filterDataFunc(mappedData, searchText);

  const handleDeleteCall = (record) => {
    setDeleteData(record);
    setIsDeleteModalOpen(true);
  };

  const updatedColumns = [
    {
      title: "Call ID",
      dataIndex: "Call ID",
      key: "Call ID",
      width: 100,
    },
    {
      title: "Call date",
      dataIndex: "Call date",
      key: "Call date",
      width: 134,
      // filterDropdown: (props) => <DateRangeFilter {...props} />,
      // onFilter: (value, record) => {
      //   if (!value || value.length !== 2) return true;

      //   const [start, end] = value;
      //   const recordDate = dayjs(record["Call date"]);

      //   return recordDate.valueOf() >= start.valueOf() && recordDate.valueOf() <= end.valueOf();
      // },
    },
    {
      title: "Start time",
      dataIndex: "Start time",
      key: "Start time",
      width: 134,
    },
    {
      title: "End time",
      dataIndex: "End time",
      key: "End time",
      width: 134,
    },
    {
      title: "Agency name",
      dataIndex: "Agency name",
      key: "Agency name",
      width: 134,
    },
    {
      title: "Circle",
      dataIndex: "Circle",
      key: "Circle",
      width: 134,
    },
    {
      title: "Call duration",
      dataIndex: "Call duration",
      key: "Call duration",
    },
    {
      title: "Call type",
      dataIndex: "Call type",
      key: "Call type",
      width: 134,
      // filters: [
      //   { text: "Outgoing", value: "Outgoing" },
      //   { text: "Incoming", value: "Incoming" },
      // ],
      // onFilter: (value, record) => value && record["Call type"] === value,
    },
    {
      title: "Agent ID",
      dataIndex: "Agent ID",
      key: "Agent ID",
      width: 134,
    },
    {
      title: "Disconnected by",
      dataIndex: "Disconnected by",
      key: "Disconnected by",
      // filters: [
      //   { text: "Customer", value: "CUSTOMER" },
      //   { text: "Agent", value: "AGENT" },
      // ],
      // onFilter: (value, record) => value && record["Disconnected by"] === value,
    },
    {
      title: "Disposition",
      dataIndex: "Disposition",
      key: "Disposition",
      width: 350,
    },
    {
      title: "Call status",
      dataIndex: "Call status",
      key: "Call status",
      render: (status) => <Tag color={status === "Connected" ? "green" : "red"}>{status}</Tag>,
      // filters: [
      //   { text: "Connected", value: "Connected" },
      //   { text: "Disconnected", value: "Disconnected" },
      // ],
      // onFilter: (value, record) => record["Call status"] === value,
    },
    {
      title: "Customer phone number",
      dataIndex: "Customer phone number",
      key: "Customer phone number",
    },
    {
      title: "Action",
      key: "Action",
      render: (record) => {
        const menuItems = [
          {
            key: "1",
            label: QA_ROLES.includes(role) ? "Audit Calls" : "View details",
            icon: <EyeOutlined />,
            onClick: () => {
              if (QA_ROLES.includes(role)) {
                navigate(`/audit-details/${record["Call ID"]}`);
              } else {
                setSelectedRow(record);
                setIsDetailsModalOpen(true);
              }
            },
          },
          {
            key: "2",
            label: QA_ROLES.includes(role)? "Call Details" : "Delete call",
            icon: <DeleteOutlined />,
            onClick: () => {
              if (!QA_ROLES.includes(role)) {
                handleDeleteCall(record);
              } else {
                // console.log("Call Details clicked");
              }
            },
          },
        ];

        return (
          <Dropdown
            menu={{
              items: menuItems,
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <EllipsisOutlined style={{ fontSize: 20 }} />
              </Space>
            </a>
          </Dropdown>
        );
      },
    },
  ];

  useEffect(() => {
    // fetchData();
    fetchOverview();
  }, []);

  return (
    <>
      <>
        <div className="container-fluid">
          <div className="">
            <OverviewSection overviewData={overviewData} />
            {/* <div style={{ marginTop: "50px" }}>
              <FilterSection />
            </div> */}
          </div>
          <DataTable
            updatedColumns={updatedColumns}
            callApiArgs={{
              endpoint: "calls/summary",
              bodyData: {
                action: "READ_ALL",
                input: {},
              },
              apiMethod: "post",
              dependencies: [fetchRefresh],
            }}
          />
        </div>
        <DeleteModal
          handleCancel={handleCancel}
          open={isDeleteModalOpen}
          handleDelete={handleDelete}
          title={"Delete call?"}
          description={"Are you sure you want to delete this call?"}
        />
      </>
      <AssignedCallDetails
        open={isDetailsModalOpen}
        handleCancel={handleCancel}
        formData={selectedRow}
      />
    </>
  );
};

export default Dashboard;
